export default class Search {
  constructor({ el }) {
    this.el = el;
    this.form = this.el.querySelector('form');
    this.input = this.form.querySelector('input[type="search"]');
    this.closer = this.el.querySelector('.search-closer');
    this.openers = Array.from(document.querySelectorAll('.search-opener'));

    // this el has to be outside of the header for mix blend mode to work as expected
    this.results = document.querySelector('#predictive-search-container .results');

    this.init();
  }

  init() {
    this.openers.forEach((opener) => {
      opener.addEventListener('click', () => {
        this.open();
      });
    });

    this.input.addEventListener(
      'input',
      this.debounce((event) => {
        this.onChange(event);
      }, 300).bind(this),
    );

    this.closer.addEventListener('click', () => {
      this.close();
    });
  }

  onChange() {
    const searchTerm = this.input.value.trim();

    this.getSearchResults(searchTerm);
  }

  getSearchResults(searchTerm) {
    // if search term empty, hide results and show suggested searches
    if (!searchTerm.length) {
      this.el.classList.remove('search-in-progress');
      return;
    }

    // if there is a search term, show results
    this.el.classList.add('search-in-progress');
    this.results.innerHTML =
      '<div class="loading px-base text-xs uppercase tracking-def flex justify-center"><p>Loading...</p></div>';

    fetch(
      `/search/suggest?q=${searchTerm}&resources[type]=product,page,article,query&resources[limit]=10&resources[limit_scope]=each&resources[options][unavailable_products]=hide&section_id=predictive-search`,
    )
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.status);
          this.close();
          throw error;
        }

        return response.text();
      })
      .then((text) => {
        const resultsMarkup = new DOMParser()
          .parseFromString(text, 'text/html')
          .querySelector('#shopify-section-predictive-search').innerHTML;
        this.results.innerHTML = resultsMarkup;
        // this.open();
      })
      .catch((error) => {
        this.close();
        throw error;
      });
  }

  open() {
    this.input.value = '';
    this.el.classList.add('active');
    this.input.focus();
  }

  close() {
    this.el.classList.remove('active');

    setTimeout(() => {
      this.input.value = '';
    }, 350);
  }

  debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}
